import { render, staticRenderFns } from "./createPost.vue?vue&type=template&id=57e5acd1&scoped=true"
import script from "./createPost.vue?vue&type=script&lang=js"
export * from "./createPost.vue?vue&type=script&lang=js"
import style0 from "./createPost.vue?vue&type=style&index=0&id=57e5acd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e5acd1",
  null
  
)

export default component.exports